import HeroGradientText from "@/components/heroGradientText/heroGradientText";
import styles from "./home.module.scss";
import ProductsTabsSectionV2 from "@/components/productsTabsSectionV2/productsTabsSectionV2";
import FeaturesSwiper from "@/components/featuresSwiper/featuresSwiper";
import { ThreeSteps } from "@/components/threeSteps/threeSteps";
import FaqWithCta from "@/components/faqWithCta/faqWithCta";
import Head from "next/head";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import AutoPlayTabsWithProgress from "@/components/autoPlayTabs/autoPlayTabs";

function Home() {
  const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState("");
  const [domainUrl, setDomainUrl] = useState("");
  useEffect(() => {
    if (window.location.href) {
      setCurrentUrl(window.location.href);
      setDomainUrl(window.location.hostname);
    }
  }, []);

  const baseUrl = `https://${domainUrl || "qrhub.io"}`;
  const defaultOgImage = `${process.env.NEXT_PUBLIC_MAIN_WEBSITE_URL}/images/featured_images/qrhub-featured.jpg`;
  const defaultOgUrl = currentUrl || `${baseUrl}${router.asPath || ""}`;

  return (
    <>
      <Head>
        <title>QRHUB - Reliable Static & Dynamic QR Code Generator</title>
        <meta
          name="description"
          content="Get fully customizable Dynamic and Static QR Code Solutions from QRHUB. Create a free account, generate, and download QR Codes for your personal and business needs."
        />
        <meta
          property="og:title"
          content="QRHUB - Reliable Static & Dynamic QR Code Generator"
        />
        <meta
          property="og:description"
          content="Get fully customizable Dynamic and Static QR Code Solutions from QRHUB. Create a free account, generate, and download QR Codes for your personal and business needs."
        />
        <meta property="og:image" content={defaultOgImage} />
        <meta property="og:url" content={defaultOgUrl} />
      </Head>
      <div className={`${styles["home"]}`}>
        <HeroGradientText />
        <ThreeSteps />
        <ProductsTabsSectionV2 />
        <FeaturesSwiper />
        <FaqWithCta
          title="Ready to get started?"
          description="Sign up now and begin creating fully customizable QR Codes for your needs instantly."
          buttonTitle="Try for free"
          buttonUrl={process.env.NEXT_PUBLIC_DASHBOARD_URL}
          target={"_blank"}
        />
      </div>
    </>
  );
}

export default Home;
